import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import style from './style'

const Component = ({
  allowedCountryCodes = ['CA', 'US'],
  classes,
  error = false,
  required = true,
  helperText = '',
  isOpen = false,
  isLoading = false,
  onChange,
  onClose,
  title = 'Send SMS',
  contentText = '',
  onSend,
  onCancel,
  leftButtonLabel = 'Cancel',
  rightButtonLabel = 'Send',
  closeButtonLabel = 'Ok',
  cypress_id,
  succeed = false,
  value,
}) => {
  const onInputChange = value => {
    let error = ''
    // Remove all non-digit characters
    let phoneNumber = value.replace(/\D/g, '')
    // Format phone number based on country code
    let countryCode = ''
    if (phoneNumber.length > 10) {
      countryCode = phoneNumber.slice(0, 1)
    }

    if (phoneNumber) {
      if (
        (allowedCountryCodes.includes('US') ||
          allowedCountryCodes.includes('CA')) &&
        countryCode === '1'
      ) {
        // United States and Canada phone number
        phoneNumber = phoneNumber.slice(0, 11)
        error = ''
      } else if (
        allowedCountryCodes.includes('CR') ||
        allowedCountryCodes.includes('UA')
      ) {
        error = ''
      } else {
        error = 'Invalid phone number'
      }
    } else {
      error = 'Phone number value is required'
    }

    onChange(phoneNumber, error)
  }

  return (
    <Dialog open={isOpen} onClose={onClose} disableEnforceFocus={true}>
      <DialogTitle cypress_id={`${cypress_id}-title`}>{title}</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <LoadingIndicator label="Loading" />
        ) : (
          <React.Fragment>
            <DialogContentText cypress_id={`${cypress_id}-text`}>
              {contentText}
            </DialogContentText>
            <Box
              alignItems="center"
              display="flex"
              justifyContent="space-between"
            >
              <span className={succeed ? classes.plusSend : classes.plus}>
                +
              </span>
              <TextField
                autoFocus
                className={classes.textField}
                error={error}
                helperText={helperText}
                cypress_id={`${cypress_id}-phone-number-text-field`}
                margin="dense"
                label="Phone Number"
                type="tel"
                onChange={event => onInputChange(event.target.value)}
                variant="standard"
                value={value}
              />
            </Box>
          </React.Fragment>
        )}
      </DialogContent>
      <DialogActions>
        {!succeed && onCancel && (
          <Button
            disabled={isLoading}
            onClick={onCancel}
            color="primary"
            cypress_id={`${cypress_id}-cancel-button`}
          >
            {leftButtonLabel}
          </Button>
        )}
        {!succeed && onSend && (
          <Button
            disabled={
              isLoading || Boolean(error) || (required && !Boolean(value))
            }
            onClick={onSend}
            color="primary"
            autoFocus
            cypress_id={`${cypress_id}-send-button`}
          >
            {rightButtonLabel}
          </Button>
        )}
        {succeed && onClose && (
          <Button
            disabled={isLoading}
            onClick={onClose}
            color="primary"
            cypress_id={`${cypress_id}-close-button`}
          >
            {closeButtonLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

const PhoneNumberDialog = withStyles(style)(Component)

export { PhoneNumberDialog }
